export class Weapon extends Phaser.Physics.Arcade.Image {
	cost: number;
	spent: number;
	flagID:string;
	text: Phaser.GameObjects.Text;
	gunType: string;

	constructor(scene: Phaser.Scene, x: number, y: number) {
		super(scene, x, y, "sprites", "gun.png");
		this.text = scene.add.text(x,y-32,"",{ fontFamily: "Arial", fontSize: 16, color: "#00ff00" });
	}

	create(x: number, y: number, cost: number, id: string, type: string): void {
		this.body.immovable = true;
		this.flagID = id;
		this.x = x;
		this.y = y;
		this.cost = cost;
		this.spent = 0;
		this.gunType = type;
		this.text.setPosition(this.x-this.gunType.length*8,this.y-32);
	}

	update(time: number, delta: number): void {
		// if(this.spent >= this.cost) {
		// 	this.text.destroy();
		// 	this.destroy();
		// }
	}

	afford(money: number): boolean {
		if(money >= this.cost - this.spent) {
			return true;
		}
		return false;
	}

	showCost(): void {
		this.text.setText(`${this.gunType} ¥${this.cost}`);
	}

	hideCost(): void {
		this.text.setText(``);
	}

	buy(): number {
		if(this.spent === this.cost) {
			return 0;
		}
		this.spent = this.cost;
		return this.cost;
	}
}
